import _ from "lodash";

import { expirer } from "@/utils/expirer";
import * as k4util from "@/utils/k4util";

export default {
	namespaced: false,

	getters: {
		nodeByGuidLive: (state, getters, rootState) => guid =>
			_.get(rootState.controller.nodes.nodes, guid),
	},

	actions: {
		async addLive({ getters }, { name, parent, description, subpath = null }) {
			let liveNode = parent ? getters.liveNodeByGuid(parent) : getters.$model;
			if (!liveNode) {
				throw new Error("Target parent node no longer exists");
			}
			if (subpath) liveNode = liveNode.child(subpath);

			await liveNode.add(name, description);

			return liveNode.child(name);
		},

		async removeLive({ commit, getters }, { node }) {
			let liveNode = getters.liveNodeByPath(node.path);
			if (!liveNode) {
				throw new Error("Target node no longer exists");
			}

			const guid = liveNode.guid();
			const resp = await liveNode.parent().remove(node.name);

			// Successfully removed node from live model, now remove from
			// vuex store.
			commit("remove", guid);

			return resp;
		},

		async renameLive({ getters }, { node, name }) {
			const liveNode = getters.liveNodeByPath(node.path);
			if (!liveNode) {
				throw new Error("Target node no longer exists");
			}

			// Check if there is already a node with that name
			// NOTE: K4model should do this itself.
			if (liveNode.parent().child(name)) {
				throw new Error("A node with that name already exists");
			}

			// Rename node and update all path references to renamed node
			await k4util.rename(liveNode, name);
		},

		async moveLive({ getters }, { node, destination }) {
			const destPath = getters.nodeByGuid(destination).path;
			const liveNode = getters.liveNodeByPath(node.path);
			if (!liveNode) {
				throw new Error("The node you're trying to move no longer exists");
			}

			const destNode = getters.liveNodeByPath(destPath);
			if (!destNode) {
				throw new Error("The target location does not exist");
			}

			// NOTE: K4Model should already check for this...
			if (destNode.child(node.name)) {
				throw new Error(
					"Destination already has a child node with the same name"
				);
			}

			return k4util.move(liveNode, destPath);
		},

		async setPropertyLive({ getters }, { node, propName, propValue }) {
			const liveNode = getters.liveNodeByPath(node.path);
			if (!liveNode) {
				throw new Error(`No node found at ${node.path}`);
			}
			return liveNode.child(`properties/${propName}`).set(propValue);
		},

		async executeCommandLive({ getters }, { node, subpath, commandParams }) {
			const cmdNodePath = `${node.path}/${subpath}`;
			const liveCmdNode = getters.liveNodeByPath(cmdNodePath);
			if (!liveCmdNode) {
				throw new Error(`No node found at ${cmdNodePath}`);
			}

			const resp = await expirer(() => liveCmdNode.execute(commandParams));
			return k4util.isAckResp(resp) ? true : resp;
		},
	},
};
